
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_2026_18791)"}},[_c('path',{attrs:{"d":"M10.984 19.11c5 0 9.063-4.063 9.063-9.063H1.922a9.059 9.059 0 009.062 9.062z","fill":"#C8421D"}}),_c('path',{attrs:{"d":"M10.984.984v9.063h9.063c0-5-4.047-9.063-9.063-9.063z","fill":"#FF8F6A"}}),_c('path',{attrs:{"d":"M1.938 10.047H11V.984c-5 0-9.063 4.063-9.063 9.063z","fill":"#ED6B47"}}),_c('path',{attrs:{"d":"M9.266 15.078H.984c-.546 0-1-.453-1-1V5.922c0-.547.454-1 1-1h8.282c.546 0 1 .453 1 1v8.156c0 .547-.454 1-1 1z","fill":"#C8421D"}}),_c('path',{attrs:{"d":"M4.422 10.719v2.14H3.219V6.953h2.39c.688 0 1.235.172 1.625.516.391.343.594.797.594 1.375 0 .562-.203 1.015-.594 1.36-.39.343-.937.515-1.625.515H4.422zm0-.906h1.187c.329 0 .594-.094.766-.266a.969.969 0 00.266-.688c0-.28-.079-.515-.25-.703-.172-.187-.422-.281-.766-.281H4.437v1.938h-.015z","fill":"#fff"}}),_c('path',{attrs:{"opacity":".2","d":"M10.234 5.828v8.25c0 .547-.453 1-1 1h-5.75l.594.89h5.984c.547 0 1-.452 1-1V6.814a.955.955 0 00-.828-.985z","fill":"#000"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_2026_18791"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    